import React from 'react';
import type { PaymentMethod } from '../types/euforms';

type BrandIcon = {
  src: string;
  alt: string;
};

const BRAND_ICONS: Partial<Record<PaymentMethod, BrandIcon>> = {

  'MB WAY': {
    src: '/payment-icons/mbway.webp',
    alt: 'MB WAY',
  },

  Multibanco: {
    src: '/payment-icons/multibanco.webp',
    alt: 'Multibanco',
  },

  'Cartão de Crédito': {
    src: '/payment-icons/credit-card.webp',
    alt: 'Visa e Mastercard',
  },

  'Google Pay': {
    src: '/payment-icons/google-pay.png',
    alt: 'Google Pay',
  },

  'Apple Pay': {
    src: '/payment-icons/apple-pay.png',
    alt: 'Apple Pay',
  },

};


type PaymentMethodIconProps = {

  method: PaymentMethod;

  className?: string;

};


const PaymentMethodIcon = ({
                             method,
                             className = 'h-8 w-auto max-w-12',
                           }: PaymentMethodIconProps) => {

  const brand =
      BRAND_ICONS[method];

  /*
   * Métodos que utilizam imagem oficial.
   */
  if (brand) {

    return (

        <img
            src={brand.src}
            alt={brand.alt}
            title={brand.alt}
            draggable={false}
            loading="eager"
            className={`
          ${className}
          block
          object-contain
        `}
            style={{
              objectFit: 'contain',
              flexShrink: 0,
            }}
        />

    );
  }


  /*
   * Numerário
   *
   * Fallback SVG para métodos sem
   * imagem de marca própria.
   */
  return (

      <svg
          viewBox="0 0 24 24"
          aria-label="Numerário"
          role="img"
          className={className}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
      >

        <rect
            x="3"
            y="6"
            width="16"
            height="11"
            rx="2"
        />

        <path
            d="M7 9h8M7 14h8M6 19h15V9"
        />

        <circle
            cx="11"
            cy="11.5"
            r="1.5"
        />

      </svg>

  );
};

export default PaymentMethodIcon;